import { AvForm } from 'availity-reactstrap-validation'
import RenderFields from '../../../CMSComponent/Forms/renderFields'
import { useEffect, useRef, useState } from 'react'
import { primary_color } from '../../../Helper/uiHelper'
import { request } from '../../../Redux/Sagas/requests/api'
import { useDispatch, useSelector } from 'react-redux'
import { setNotification } from '../../../Redux/Reducers/notificationHandling'
import { isSuccessResponse } from '../../../helper'
import Loader from 'react-loaders'
import { fetchUpdateApiData } from '../../../Redux/Reducers/CMS'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'

const extractLockerTypeIds = (values, formFieldValue) => {
  let raw = values?.locker_type_ids ?? formFieldValue?.locker_type_ids ?? []
  if (raw == null || raw === '') return []
  if (!Array.isArray(raw)) raw = [raw]
  return raw
    .map((row) => {
      if (typeof row === 'object' && row !== null) {
        return row?.value ?? row?.id
      }
      return row
    })
    .filter((id) => id !== null && id !== undefined && id !== '')
}

/** Normalize Lock Type multi-select to [{ value, label }, ...] for CMSSelect remount */
const normalizeLockTypeOptions = (raw, labels) => {
  if (raw == null || raw === '') return []
  const arr = Array.isArray(raw) ? raw : [raw]
  const labelArr = Array.isArray(labels) ? labels : labels != null && labels !== '' ? [labels] : []
  return arr
    .map((row, i) => {
      if (typeof row === 'object' && row !== null) {
        const value = row?.value ?? row?.id
        if (value == null || value === '') return null
        return { value, label: row?.label ?? labelArr[i] ?? String(value) }
      }
      if (row == null || row === '') return null
      return { value: row, label: labelArr[i] ?? String(row) }
    })
    .filter(Boolean)
}

const BlockMainDetails = ({ setBlocketails, blockDetails, form, onCloseForm, isPlannedBlock, isTemplateImported, setIsTemplateImported }) => {
  const dispatch = useDispatch()
  const saveNclose = useRef()
  const lastValidLockTypesRef = useRef([])
  const isRollingBackLockTypesRef = useRef(false)
  const rowData = useSelector((state) => state.CMS.currentRow)
  const [formFieldValue, setFormFieldValue] = useState()
  const [importFormFieldValue, setImportFormFieldValue] = useState()
  const [loading, setLoading] = useState(false)
  const [mainForm, setMainForm] = useState({})
  const [importForm, setImportForm] = useState({})
  const [isMainFormDisabled, setIsMainFormDisabled] = useState(false)
  const [isImportingLoading, setIsImportingLoading] = useState(false)
  const [isImportError, setIsImportError] = useState(false)
  const [showImportForm, setShowImportForm] = useState(false)
  const [showBlockGroup, setShowBlockGroup] = useState(true)
  const [conflictOpen, setConflictOpen] = useState(false)
  const [conflictMessage, setConflictMessage] = useState('')
  const [blockGroupModal, setBlockGroupModal] = useState({ open: false, pendingValues: null, soldCount: 0 })
  const [formDefaults, setFormDefaults] = useState({})
  const [lockTypeFieldKey, setLockTypeFieldKey] = useState(0)

  useEffect(() => {
    const defaults = blockDetails || {}
    setFormDefaults(defaults)
    const initial = normalizeLockTypeOptions(defaults?.locker_type_ids, defaults?.locker_type_ids_label)
    if (initial.length) {
      lastValidLockTypesRef.current = initial
    }
  }, [blockDetails?.id, JSON.stringify(blockDetails?.locker_type_ids)])

  useEffect(() => {
    if (isPlannedBlock || rowData?.length === 2 || isTemplateImported) {
      setMainForm(form)
    } else {
      setIsMainFormDisabled(true)
      setShowImportForm(true)
      setMainForm(form)
      const importFormCopy = form && JSON.parse(JSON.stringify(form))
      importFormCopy['component_call_fields'] = importFormCopy?.component_call_fields?.filter(
        (item) => item?.field_id === 'item_date_time_id' || item?.field_id === 'template_id'
      )
      setImportForm(importFormCopy)
    }
  }, [rowData?.length])

  const rememberValidLockTypes = (source) => {
    const opts = normalizeLockTypeOptions(source?.locker_type_ids, source?.locker_type_ids_label)
    if (opts.length) {
      lastValidLockTypesRef.current = opts
    }
  }

  const rollbackInvalidLockTypes = () => {
    setConflictOpen(false)
    const restored = lastValidLockTypesRef.current || []
    const ids = restored.map((o) => o.value)
    const labels = restored.map((o) => o.label)
    isRollingBackLockTypesRef.current = true
    setFormFieldValue((prev) => ({
      ...(prev || {}),
      locker_type_ids: ids,
      locker_type_ids_label: labels,
    }))
    setFormDefaults((prev) => ({
      ...(prev || blockDetails || {}),
      locker_type_ids: restored,
      locker_type_ids_label: labels,
    }))
    setLockTypeFieldKey((k) => k + 1)
    // Recompute Block Group visibility from restored selection
    if (!ids.length) {
      setShowBlockGroup(true)
      isRollingBackLockTypesRef.current = false
      return
    }
    request('automatic-codes/validate-lock-types', 'POST', { locker_type_ids: ids }).then((res) => {
      if (res?.status === 200) {
        setShowBlockGroup(!!res?.data?.show_block_group)
      }
      isRollingBackLockTypesRef.current = false
    })
  }

  // Show Block Group only when selected Lock Types are all Block Codes
  useEffect(() => {
    if (isRollingBackLockTypesRef.current) return
    const ids = extractLockerTypeIds({}, formFieldValue || formDefaults || blockDetails || {})
    if (!ids.length) {
      setShowBlockGroup(true)
      return
    }
    request('automatic-codes/validate-lock-types', 'POST', { locker_type_ids: ids }).then((res) => {
      if (res?.status === 200) {
        if (res?.data?.conflict) {
          setConflictMessage(res?.data?.message || 'Lock Types must share the same code category.')
          setConflictOpen(true)
          return
        }
        setShowBlockGroup(!!res?.data?.show_block_group)
        rememberValidLockTypes(formFieldValue || formDefaults || blockDetails || {})
      }
    })
  }, [JSON.stringify(formFieldValue?.locker_type_ids || formDefaults?.locker_type_ids || blockDetails?.locker_type_ids)])

  useEffect(() => {
    setMainForm((prev) => {
      if (!prev?.component_call_fields) return prev
      const next = JSON.parse(JSON.stringify(prev))
      next.component_call_fields = next.component_call_fields.map((field) => {
        if (field?.field_id === 'block_group_id' || field?.name === 'block_group_id') {
          // RenderFields treats hidden as 0/1 (and true) for layout fields
          return { ...field, hidden: showBlockGroup ? 0 : 1 }
        }
        if (field?.title === 'Locker Type' || field?.placeholder === 'Locker Type') {
          return { ...field, title: 'Lock Type', placeholder: 'Lock Type' }
        }
        return field
      })
      return next
    })
  }, [showBlockGroup, form])

  const saveBlock = (values, extra = {}) => {
    const domain_id = rowData?.[0]?.id
    const payloadValues = { ...values, ...extra }
    if (!showBlockGroup) {
      payloadValues.block_group_id = null
    }
    setLoading(true)
    request('location-manage', 'POST', {
      locations: [{ ...payloadValues, domain_id, id: blockDetails?.id }],
      is_planned_block: isPlannedBlock,
      copy_from_template: blockDetails?.id ? false : true,
    }).then((res) => {
      if (res.status === 200 || res.status === 202 || res.status === 201) {
        dispatch(setNotification({ type: 'success', message: 'Form submitted successfully!' }))
        request('get-location-data', 'POST', { location_id: res?.data?.id, is_planned_block: isPlannedBlock }).then((locRes) => {
          if (locRes?.status === 200 || locRes?.status === 201 || locRes?.status === 202) {
            setBlocketails(locRes?.data)
          }
          setLoading(false)
          if (saveNclose.current) {
            onCloseForm()
          }
        })
      } else {
        dispatch(setNotification({ type: 'error', message: res?.data?.message || 'Something went wrong!' }))
        setLoading(false)
      }
    })
  }

  const onSubmitBlockDetails = (values) => {
    const ids = extractLockerTypeIds(values, formFieldValue)
    const runSave = () => {
      const originalGroup = blockDetails?.block_group_id
      const nextGroup = showBlockGroup ? values?.block_group_id ?? null : null
      const groupChanged = blockDetails?.id && String(originalGroup || '') !== String(nextGroup || '')

      if (groupChanged && !isPlannedBlock) {
        request('automatic-codes/change-block-group', 'POST', {
          location_id: blockDetails.id,
          block_group_id: nextGroup,
          action: 'preview',
          is_planned_block: false,
        }).then((res) => {
          if (res?.status === 200 && res?.data?.requires_confirm) {
            setBlockGroupModal({ open: true, pendingValues: values, soldCount: res?.data?.sold_count || 0 })
          } else {
            // 0 sold or preview failed — change group then save rest
            request('automatic-codes/change-block-group', 'POST', {
              location_id: blockDetails.id,
              block_group_id: nextGroup,
              action: 'change_no_email',
            }).finally(() => saveBlock(values))
          }
        })
        return
      }
      saveBlock(values)
    }

    if (!ids.length) {
      runSave()
      return
    }
    request('automatic-codes/validate-lock-types', 'POST', { locker_type_ids: ids }).then((res) => {
      if (res?.status === 200 && res?.data?.conflict) {
        setConflictMessage(res?.data?.message || 'Lock Types must share the same code category.')
        setConflictOpen(true)
        setLoading(false)
        return
      }
      if (res?.status === 200) {
        setShowBlockGroup(!!res?.data?.show_block_group)
        rememberValidLockTypes(values || formFieldValue || {})
      }
      runSave()
    })
  }

  const confirmBlockGroupChange = (action) => {
    const values = blockGroupModal.pendingValues
    setBlockGroupModal({ open: false, pendingValues: null, soldCount: 0 })
    if (action === 'cancel' || !values) return
    request('automatic-codes/change-block-group', 'POST', {
      location_id: blockDetails.id,
      block_group_id: showBlockGroup ? values?.block_group_id ?? null : null,
      action,
    }).then((res) => {
      if (res?.status === 200) {
        saveBlock(values)
      } else {
        dispatch(setNotification({ type: 'error', message: res?.data?.message || 'Failed to change Block Group' }))
      }
    })
  }

  useEffect(() => {
    setIsImportError(false)
    if (!importFormFieldValue?.template_id || !importFormFieldValue?.item_date_time_id) {
      return
    }
    const domain_id = rowData?.[0]?.id
    setIsImportingLoading(true)
    request('get-existing-locations-data', 'POST', {
      template_id: importFormFieldValue?.template_id,
      item_date_time_id: importFormFieldValue?.item_date_time_id,
      domain_id,
    }).then((res) => {
      if (isSuccessResponse(res)) {
        if (res?.data?.length === 0) {
          request('get-location-data', 'POST', { location_id: importFormFieldValue?.template_id, is_planned_block: true }).then((locRes) => {
            if (isSuccessResponse(locRes)) {
              const { id, ...rest } = locRes?.data
              setBlocketails({ ...rest, ...importFormFieldValue })
              setImportForm({})
              setIsImportingLoading(false)
              setIsMainFormDisabled(false)
              setShowImportForm(false)
              setIsTemplateImported(true)
            }
          })
        } else {
          setIsImportError(true)
        }
        setIsImportingLoading(false)
      } else {
        setIsImportingLoading(false)
      }
    })
  }, [importFormFieldValue])

  const onSyncTemplate = () => {
    request('sync-template', 'POST', { template_id: blockDetails?.template_id, block_id: blockDetails?.id }).then((res) => {
      isSuccessResponse(res, 'Template synced successfully!')
    })
  }
  return (
    <div className='m-5'>
      {showImportForm && (
        <div className='mb-5'>
          <AvForm
            onValidSubmit={(e, values) => {
              setLoading(true)
              onSubmitBlockDetails(values)
            }}>
            <RenderFields
              allForm={[importForm]}
              content={[importForm]}
              twoCol={true}
              formFieldValue={importFormFieldValue}
              setFormFieldValue={setImportFormFieldValue}
              defaultFormValue={{}}
              noCache={true}
            />
          </AvForm>
        </div>
      )}

      {isImportingLoading && (
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}>
          <Loader type='ball-pulse' color='blue' />
        </div>
      )}
      {isImportError && (
        <div className='alert alert-danger' role='alert'>
          Block already exist
        </div>
      )}

      {!isPlannedBlock && !isMainFormDisabled && formFieldValue?.template_id && (
        <Button
          className='mb-4 subtitle1'
          color='primary'
          onClick={() => {
            onSyncTemplate()
          }}>
          Sync
        </Button>
      )}

      <div>
        <AvForm
          className={`${isMainFormDisabled && 'disabled-pill'}`}
          onValidSubmit={(e, values) => {
            setLoading(true)
            onSubmitBlockDetails(values)
          }}>
          <RenderFields
            key={`block-main-fields-${lockTypeFieldKey}`}
            allForm={[mainForm]}
            content={[mainForm]}
            twoCol={true}
            formFieldValue={formFieldValue}
            setFormFieldValue={setFormFieldValue}
            defaultFormValue={formDefaults || blockDetails || {}}
            noCache={true}
            disabled_field={['template_id']}
          />
          <div className='d-flex justify-content-end mt-5'>
            {' '}
            <button
              className='btn rounded-pill mt-2 text-danger border-danger mr-3'
              type='button'
              id='close-btn'
              onClick={(e) => {
                onCloseForm()
                e.preventDefault()
                e.stopPropagation()
              }}
              style={{ fontWeight: 700, width: '12rem' }}>
              Close
            </button>
            <button
              className='btn text-white rounded-pill mt-2 mr-3'
              disabled={!!loading}
              type='submit'
              id='save-button'
              style={{ background: primary_color, fontWeight: 700, width: '14rem' }}>
              {loading ? 'Saving...' : 'Save'}
            </button>
            <button
              className='btn text-white rounded-pill mt-2'
              disabled={!!loading}
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                saveNclose.current = true
                const ele = document.getElementById('save-button')
                if (ele) {
                  ele.click()
                }
              }}
              type='submit'
              style={{ background: primary_color, fontWeight: 700, width: '14rem' }}>
              Save & Close
            </button>
          </div>
        </AvForm>
      </div>

      <Modal isOpen={conflictOpen} toggle={rollbackInvalidLockTypes} centered style={{ boxShadow: 'none' }}>
        <ModalHeader toggle={rollbackInvalidLockTypes}>Lock Type conflict</ModalHeader>
        <ModalBody>{conflictMessage}</ModalBody>
        <ModalFooter>
          <Button color='primary' style={{ background: primary_color, border: 'none' }} onClick={rollbackInvalidLockTypes}>
            OK
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={blockGroupModal.open} toggle={() => confirmBlockGroupChange('cancel')} centered style={{ boxShadow: 'none' }}>
        <ModalHeader toggle={() => confirmBlockGroupChange('cancel')}>Change Block Group</ModalHeader>
        <ModalBody>
          This block has {blockGroupModal.soldCount} sold locker(s). How do you want to proceed?
        </ModalBody>
        <ModalFooter className='d-flex flex-column align-items-stretch' style={{ gap: '0.5rem' }}>
          <Button color='primary' style={{ background: primary_color, border: 'none' }} onClick={() => confirmBlockGroupChange('change_reissue')}>
            Re-issue confirmation emails
          </Button>
          <Button color='warning' onClick={() => confirmBlockGroupChange('change_no_email')}>
            Change without email
          </Button>
          <Button color='secondary' onClick={() => confirmBlockGroupChange('cancel')}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  )
}

export default BlockMainDetails
